<template>
  <q-page padding class="window-height window-width row justify-center items-center">
    <div class="column full-width">
      <div class="row">

      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4 offset-md-4">
          <q-card dark :bordered="!isMobile" class="q-pa-lg"
                  :class="{ 'shadow-4': !isMobile }">
            <h5 class="text-h5 text-white q-my-md text-center">Forgot Password</h5>
            <p class="text-bold text-body1 text-center text-negative">{{ error }}</p>
            <q-form
              @submit="onSubmit"
              @reset="onReset"
              class="q-gutter-md q-mt-md"
            >
              <q-input
                ref="emailRef"
                dark
                filled
                standout
                color="secondary"
                v-model="email"
                type="email"
                label="Email Address"
                hint="Enter your email"
                lazy-rules
                autofocus
                :rules="fieldEmailRules"
              />

              <div class="q-mt-md">
                <q-btn label="Reset" type="submit" color="secondary" class="full-width" :loading="loading" size="lg"/>
              </div>
            </q-form>
          </q-card>
          <h5 class="text-body2 text-white q-my-md text-center">Remember your password? <span class="text-secondary text-bold cursor-pointer" @click="onSignIn">Sign in here</span></h5>
        </div>
      </div>
    </div>
  </q-page>
</template>
<script>
import { ref } from "vue"
import { useRouter } from "vue-router"
import { loggerFactory } from '../../logger'
import { useUserStore } from '../../stores/user-store'
import { useQuasar } from "quasar"

const logger = loggerFactory("ForgotPage")
export default {
  name: "ForgotPage",
  setup() {
    const $q = useQuasar()
    const isMobile = $q.platform.is.mobile
    const router = useRouter()
    const store = useUserStore()
    const error = ref(null)
    const email = ref(null)
    const emailRef = ref(null)
    const loading = ref(false)

    const fieldEmailRules = ref([
      val => !!val || "Email is required"
    ])

    const notifyError = (message) => {
      $q.notify({ type: "negative", message: message, timeout: 2500 })
    }

    const onSubmit = () => {
      emailRef.value.validate()

      if(emailRef.value.hasError) {
        notifyError("Please complete all fields before continuing.")
        return
      }

      logger.debug("Login user", email.value)
      loading.value = true
      const finalEmail = email.value.trim()
      store.passwordReset(finalEmail)
        .then((user) => {
          logger.debug('Reset password complete...')
          router.replace({ path: "/auth/login-forgot" })
        })
        .catch((err) => {
          error.value = err.message
          notifyError(err.message)
        })
        .finally(() => loading.value = false)
    }

    const onReset = () => {
      email.value = null
      emailRef.value.resetValidation()
    }

    const onSignIn = () => {
      router.replace({ path: '/auth/login' })
    }

    return {
      isMobile,
      error,
      email,
      emailRef,
      loading,
      fieldEmailRules,
      onSubmit,
      onReset,
      onSignIn
    }
  }
}
</script>
<style scoped>
</style>
